// Phase 6.B-3-redo — 설정 탭 layout. PageHeader + 좌측 SectionNav + 우측 Outlet.
//
// 사용자 결정 (2026-04-26 redo):
//   SectionNav 6 항목 (순서 고정):
//     1. 매장분류    (활성)
//     2. 레시피      (신규 활성, 6.B-3-redo)
//     3. 수집        (placeholder, 예정)
//     4. 윈도우프로그램 (placeholder, 예정)
//     5. 거래처       (placeholder, 예정)
//     6. 직원         (placeholder, 예정)
//   - "연동" 항목 제거 (시안에 없음, 6.B-4 시점 위치 재결정)
//   - 매장분류 children (배민/쿠팡이츠/...) 미노출 유지

import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { PageHeader } from '../../components/chrome';
import {
  SettingsSectionNav,
  type SectionNavItem,
} from '../../components/settings/section-nav';
import { useViewport } from '../../lib/useViewport';

const ITEMS: SectionNavItem[] = [
  {
    id: 'stores',
    label: '매장분류',
    icon: 'store',
    sub: '플랫폼 · 상점 · 메뉴',
  },
  {
    id: 'recipes',
    label: '레시피',
    icon: 'package',
    sub: '메뉴 → 재료 → 자동차감',
  },
  {
    id: 'collect',
    label: '수집',
    icon: 'receipt',
    sub: '수신기 영수증 · 분류',
  },
  {
    id: 'download',
    label: '윈도우프로그램',
    icon: 'package',
    sub: '수신기 다운로드 · 설치 가이드',
  },
  {
    id: 'suppliers',
    label: '거래처',
    icon: 'truck',
    sub: '발주 연결',
  },
  {
    id: 'staff',
    label: '직원',
    icon: 'user',
    sub: '일정 · 알림 연동',
  },
  {
    id: 'integrations',
    label: '연동',
    icon: 'activity',
    sub: 'BoxHero · 외부 시스템',
  },
];

const PATH_BY_ID: Record<string, string> = {
  stores: '/settings/stores',
  recipes: '/settings/recipes',
  collect: '/settings/collect',
  download: '/settings/download',
  suppliers: '/settings/suppliers',
  staff: '/settings/staff',
  integrations: '/settings/integrations',
};

function activeFromPath(pathname: string): string {
  if (pathname.startsWith('/settings/recipes')) return 'recipes';
  if (pathname.startsWith('/settings/collect')) return 'collect';
  if (pathname.startsWith('/settings/download')) return 'download';
  if (pathname.startsWith('/settings/suppliers')) return 'suppliers';
  if (pathname.startsWith('/settings/staff')) return 'staff';
  if (pathname.startsWith('/settings/integrations')) return 'integrations';
  return 'stores';
}

export function SettingsLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const active = activeFromPath(location.pathname);
  const viewport = useViewport();
  const isMobile = viewport === 'mobile';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
      }}
    >
      <div style={{ marginLeft: isMobile ? -14 : -24, marginRight: isMobile ? -14 : -24 }}>
        <PageHeader
          viewport={isMobile ? 'mobile' : 'desktop'}
          title="설정"
          date="매장 · 메뉴 · 레시피"
        >
          <span />
        </PageHeader>
      </div>
      <div
        style={{
          // Phase 6.C-5 — 모바일에서는 sidebar 가 위 + Outlet 아래로 stack
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : '240px 1fr',
          gap: isMobile ? 12 : 20,
          alignItems: 'start',
        }}
      >
        <SettingsSectionNav
          items={ITEMS}
          current={active}
          onSelect={(id) => {
            const to = PATH_BY_ID[id];
            if (to) navigate(to);
          }}
        />
        <div style={{ minWidth: 0 }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
